import axios from 'axios'

import * as config from '@/config.json'

export async function callSalesApi(params) {
  const url = `${ config.default.urlBaseFdv }/sales/search`

  return axios({
      url: url,
      method: 'get',
      params: params,
      headers: { 'authorization': `${ config.default.authorizationToken }` }
    })
    .catch(error => console.error({ errorMessage: `[call-api|sales|callSalesApi] ${ error }` }))
}